(function( $ ) {
	'use strict';

	/**
	 * The global object for the plugin.
	 * Should already exist due to wp_localize_script.
	 *
	 * @since 1.0.0
	 *
	 * @see   /public/class-em-cookie-notification-public.php
	 * @var   {Object}
	 */
	const EmCookieNotification = window.EmCookieNotification || {};

	/**
	 * Plugin Settings.
	 */
	var hideInUS = ( EmCookieNotification.hide_in_us === "1" ? true : false ); // Boolean.
	var googleAPIKey = EmCookieNotification.api; // String.

	/**
	 * Defines cookie active class. Added to `<body>` tag.
	 * @var {String}
	 */
	var cookieActiveClass = 'has-cookie';

	/**
	 * Creates a cookie.
	 * @param {String}  name  The name of the cookie.
	 * @param {String}  value The value of the cookie.
	 * @param {Integer} days  The number of days to store the cookie for.
	 */
	function createCookie(name,value,days) {
		var expires = "";
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days*24*60*60*1000));
			expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + value + expires + "; path=/";
	}

	/**
	 * Reads a cookie.
	 * @param {String}  name  The name of the cookie.
	 */
	function readCookie(name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for(var i=0;i < ca.length;i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1,c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
		}
		return null;
	}

	/**
	 * Erases a cookie.
	 * @param {String}  name  The name of the cookie.
	 */
	function eraseCookie(name) {
		createCookie(name,"",-1);
	}

	/**
	 * Displays the cookie notification.
	 */
	function showCookieNotification() {
		// Make sure cookie notification is displayed.
		$('.cookie-notification').show();
		// Add class to body for CSS styling.
		$('body').addClass(cookieActiveClass);
	}

	/**
	 * Hides the cookie notification.
	 */
	function hideCookieNotification() {
		// Make sure cookie notification is hidden.
		$('.cookie-notification').css('opacity', '0');
		setTimeout( function() {
			$('.cookie-notification').css('display', 'none');
		}, 300 );
		// Add class to body for CSS styling.
		$('body').removeClass(cookieActiveClass);
	}

	/**
	 * Returns today's date as an integer in yyyymmdd format.
	 */
	function getDateNow() {
		// New Date instance.
		const today = new Date();
		// Day.
		let dd = today.getDate();
		// Month. January is 0!
		let mm = today.getMonth() + 1;
		// Year.
		const yyyy = today.getFullYear();

		// Leading '0' on day.
		if( dd < 10 ) {
			dd = '0' + dd;
		}
		// Leading '0' on month.
		if (mm < 10 ) {
			mm = '0' + mm;
		}

		return parseInt( `${yyyy}${mm}${dd}` );
	}

	// extract country short name (e.g. GB for Great Britain) from google geocode API result
	function getCountry( addrComponents ) {
		for (var i = 0; i < addrComponents.length; i++) {
			if (addrComponents[i].types[0] == "country") {
				return addrComponents[i].short_name;
			}
			if (addrComponents[i].types.length == 2) {
				if (addrComponents[i].types[0] == "political") {
					return addrComponents[i].short_name;
				}
			}
		}
		return false;
	}

	/**
	 * Detects country.
	 * accepted_cookies default value is false.
	 */
	function countryDetection( accepted_cookies ) {

		$.ajax({
			type: "POST",
			url: "https://www.googleapis.com/geolocation/v1/geolocate?key=" + googleAPIKey,
			data: JSON.stringify({
				"considerIp": "true",
			}),
			contentType: 'application/json',
			success: function( data ){

				// If coordinates are defined...
				if ( data.location.lat !== undefined && data.location.lng !== undefined ) {

					/**
					 * Get Country Name
					 * @type {String}
					 */
					$.get( "https://maps.googleapis.com/maps/api/geocode/json?latlng=" + data.location.lat + ", " + data.location.lng + "&key=" + googleAPIKey, function( data ) {

						var country_short_name = getCountry(data.results[0].address_components);

						// If the country is not the US.
						if ( country_short_name !== "US" ) {
							// Display the notification.
							initCookieNotification();

							// If user accepted cookies, create cookie.
							if ( accepted_cookies === true ) {
								// Create the "country" cookie and store it for 31 days.
								createCookie( "em_cookie_notification_country", country_short_name, 31 );
							}

						} else {
							// ( Only in the US ) Create the "country" cookie and store it for 31 days.
							createCookie( "em_cookie_notification_country", country_short_name, 31 );
						}
					});

				}
			},
			error: function( error ){
				// Diplay error.
				console.log( "💥 Ups! We have an error: " );
				console.log( error );
			}
		});
	}

	/**
	 * Initialize the cookie notification.
	 * Kicks things off.
	 */
	function initCookieNotification() {

		// By default, do not show cookie.
		let showCookie = false;

		// If there is no cookie set, show notification
		if ( ! readCookie( 'em_cookie_notification' ) ) {
			showCookie = true;
		} else {
			const cookieValue = JSON.parse( readCookie( 'em_cookie_notification' ) );
			// If effective date is greater than accepted date, continue. User must reacknowledge cookie notification.
			// Also, the effective date must be less than today's date, in case the reackknowledgment is scheduled.
			const serverEffectiveDate = parseInt( EmCookieNotification.effective ); // The value set in the CMS.
			// If cookie doesn't exist, get today's date.
			const cookieDateAccepted = ( typeof( cookieValue ) !== "undefined" ? cookieValue.dateAccepted : getDateNow() );

			// If server effective date is greater than the date user accepted:
			if ( serverEffectiveDate > cookieDateAccepted ) {
				// If server effective date has already passed or is equal to today's date:
				if ( serverEffectiveDate <= getDateNow() ) {
					showCookie = true;
				} else {
					// Don't show cookie.
					// The effective date is in the future.
					// User will have to reacknowledge on ' + serverEffectiveDate.
					showCookie = false;
				}
			}
		}

		// If showCookie is true, show cookie notification and add event handlers.
		if ( showCookie ) {

			// Display the notification.
			showCookieNotification();

			// Add click event to notification button.
			$( '.cookie-notification__button button' ).click(function( e ){
				e.preventDefault();
				// Set the cookie with today's date as the accepted date.
				const cookieValue = {
					dateAccepted: getDateNow()
				}

				// Only if it's hidden in the US.
				if ( hideInUS ) {
					// Create contry cookie.
					countryDetection( true );
				}

				// Create the cookie. Use server setting for expiry date (EmCookieNotification.expiry).
				createCookie( 'em_cookie_notification', JSON.stringify( cookieValue ), parseInt( EmCookieNotification.expiry ) );

				// Hide the notification.
				hideCookieNotification();
			});

		}

	}

	/**
	 * Waits until the document is loaded before kicking things off.
	 */

	$(document).ready(function() {

		/**
		 * If we don't want to display the notification in the US
		 * and the "country" cookie doesn't exists..
		 * Create one using the "short name" version of the country.
		 */
		if ( hideInUS && ! readCookie( 'em_cookie_notification_country' ) ) {
			countryDetection();
		} else {
			/**
			 * If we don't want to display the notification in the US
			 */
			if ( hideInUS && readCookie( 'em_cookie_notification_country' ) !== "US" ) {
				// Display the notification.
				initCookieNotification();

			/**
			 * If we don't care about displaying the notification in the US.
			 */
			} else if( hideInUS === false ) {
				// Display the notification.
				initCookieNotification();
			}
		}

	});

})( jQuery );
